import { FC } from 'react';
import BannerSection from './BannerSection';
import SolutionSection from './SolutionSection';
import Calendly from './Calendly';
import Faq from './Faq';
import Testimonial from './Testimonial';
import Plans from 'ui/Plans';
import StrategyTool from './StrategyTool';
import TradingLevel from './TradingLevel';
import BrokerCarousel from './BrokerCarousel';
import LaunchSteps from './LaunchSteps';
import Empanelment from './Empanelment';
import { LandingPageProps } from '../types.type';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;


const DefaultLandingPage: FC<LandingPageProps> = (props) => {
  const shouldDisableBrokerCarousel = window.currentDomain === 'www';
  return (
    <div className="landing-page">
      <div className="landing-page__banner-container">
        <BannerSection />
      </div>
      {
        !isCrypto && (
          <>
            {shouldDisableBrokerCarousel && <BrokerCarousel />}
            <Empanelment />
          </>
        )
      }
      <LaunchSteps />
      <TradingLevel />
      <StrategyTool />
      <SolutionSection />
      <Plans {...props} />
      <Testimonial />
      <Faq />
      <Calendly />
    </div>
  );
};

export default DefaultLandingPage;
